module.exports = __webpack_public_path__ + "img/4_47.b391ce2a.png";